/**
 * Storefront API Configuration
 * Centralized configuration for Shopify Storefront API credentials
 */

interface StorefrontConfig {
  storeFrontAPI: string;
  storeFrontShop: string;
}

const STOREFRONT_CONFIGS: Record<string, StorefrontConfig> = {
  "srreceta.com": {
    storeFrontAPI: 'fff10aa973d4e1fc2708ef2391132c9a',
    storeFrontShop: 'srreceta.com'
  },
  "127.0.0.1:9292": {
    storeFrontAPI: 'fff10aa973d4e1fc2708ef2391132c9a',
    storeFrontShop: 'srreceta.com'
  },
  "srx-meds-qa.myshopify.com": {
    storeFrontAPI: 'a431ff5b0aa61b2f3521f6f7ba2f258b',
    storeFrontShop: 'srx-meds-qa.myshopify.com'
  }
};

// Default configuration (fallback to production)
const DEFAULT_CONFIG: StorefrontConfig = {
  storeFrontAPI: 'fff10aa973d4e1fc2708ef2391132c9a',
  storeFrontShop: 'srreceta.com'
};

/**
 * Get Storefront API configuration based on the current host
 * @param host - The current window.location.host value
 * @returns StorefrontConfig object with API credentials
 */
export function getStorefrontConfig(host: string): StorefrontConfig {
  return STOREFRONT_CONFIGS[host] || DEFAULT_CONFIG;
}

/**
 * Get the Storefront GraphQL API URL
 * @param host - The current window.location.host value
 * @returns The full GraphQL API URL
 */
export function getStorefrontUrl(host: string): string {
  const config = getStorefrontConfig(host);
  return `https://${config.storeFrontShop}/api/2025-10/graphql.json`;
}

/**
 * Get headers for Storefront API requests
 * @param host - The current window.location.host value
 * @returns Headers object for fetch requests
 */
export function getStorefrontHeaders(host: string): Record<string, string> {
  const config = getStorefrontConfig(host);
  return {
    "X-Shopify-Storefront-Access-Token": config.storeFrontAPI,
    "Content-Type": "application/json"
  };
}

export type { StorefrontConfig };
